module.exports = __webpack_public_path__ + "static/img/djayjay.3411fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/djayjay.png
// module id = HD/e
// module chunks = 38